import { mesaColorNames, typography } from '@/src/common/theme'
import { TouchableOpacity, Text, View, ScrollView } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import * as Updates from 'expo-updates'
import { version } from '@/package.json'
import { router } from 'expo-router'
import { Routes } from '@/src/common/enums/routes'

export const Error = () => (
  <SafeAreaView
    style={[
      {
        flex: 1,
        backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
        justifyContent: 'center',
        alignItems: 'center',
      },
    ]}
  >
    <ScrollView
      style={{ width: '100%' }}
      contentContainerStyle={{
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 12,
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          marginTop: 32,
          paddingHorizontal: 12,
        }}
      >
        <Text style={[typography['heading/heading4'], { textAlign: 'center' }]}>
          Oops, something went wrong.
        </Text>
      </View>
      <Text
        style={[
          { marginVertical: 16, marginBottom: 32, lineHeight: 24, textAlign: 'center' },
          typography['label/md-regular'],
        ]}
      >
        We're looking into it, please restart the app and contact us @ support@mesamember.com if the
        issue persists
      </Text>

      <TouchableOpacity
        onPress={() => router.replace(Routes.Main.route)}
        style={{ justifyContent: 'center', alignItems: 'center' }}
      >
        <Text
          style={[
            { color: mesaColorNames['Mesa Primary Scale/500 #00C7B6'] },
            typography['label/lg-regular'],
          ]}
        >
          Back Home
        </Text>
      </TouchableOpacity>

      <Text style={{ marginVertical: 16, marginBottom: 32, lineHeight: 24, textAlign: 'center' }}>
        {`${version}${Updates.updateId ? `@${Updates.updateId}` : ''}`}
      </Text>
    </ScrollView>
  </SafeAreaView>
)
